import React from "react";
import bg from "./fc0fcf84-f05c-405b-aeec-5f9512c5422e.png"; // ✅ Correct image import

export default function BackgroundWrapper({ children }) {
   return (
    <div className="min-h-screen relative">
      {/* Background Image */}
      <div
        className="fixed inset-0 z-0"
        style={{
          backgroundImage: `url(${bg})`,
          backgroundSize: "cover",
          backgroundPosition: "left center", // ✅ Keeps the left part always visible
          backgroundAttachment: "fixed",
        }}
      >
        {/* White overlay for readability */}
        <div className="absolute inset-0 bg-blue-300/50"></div>
      </div>

      {/* Foreground Content */}
      <div className="relative z-10">{children}</div>
    </div>
  );
}
